import React from 'react';
import mapImg from '../../assets/images/map.png';

class Contact extends React.Component {
    render(){
        return (
            <section id="contact" className="contact-area uk-contact uk-section">
                <div className="uk-container">
                    <div className="uk-section-title section-title">
                        <span>Let's Talk</span>
                        <h2>Get in Touch</h2>
                    </div>

                    <div className="uk-grid uk-grid-match uk-grid-medium uk-child-width-1-2@m uk-child-width-1-1@s">
                        <div className="item">
                            <div className="map-img">
                                <img src={mapImg} alt="map" />

                                <div className="location uk-location1">
                                    <a href="#" className="active">
                                        <div className="location-info">
                                            <h5>Lahore</h5>
                                            <span>Al Hafeez Heights, Gulberg III</span>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="item">
                            <div className="alert-success" style={{padding: '30px', borderRadius: '4px'}}>
                                <h3>Ready to Work Together?</h3>
                                <p>For inquiries, reach us at: <strong><a href="mailto:info@azntech.com">info@azntech.com</a></strong></p>
                                <p>Or call us at: <strong>+92 336 7400939</strong></p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Contact;
